var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var BaseOnePageFormModel = /** @class */ (function (_super) {
            __extends(BaseOnePageFormModel, _super);
            function BaseOnePageFormModel() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            BaseOnePageFormModel.prototype.internalSetupForm = function () {
                var _this = this;
                if (this.formConfiguration.mySteps.length > 0) {
                    this.currentStepIndex = 0;
                    this.currentStep = this.formConfiguration.mySteps[0];
                    if (this.currentStep.formSections) {
                        this.currentStep.formSections.forEach(function (fs) {
                            _this.formSectionService.splitFields(fs);
                        });
                    }
                    //this.loadStepUrls();
                }
                else {
                    if (this.isConfigureMode) {
                        var newStep = this.formService.createFormStep(this.formConfiguration);
                        newStep.position = this.formConfiguration.mySteps.length;
                        newStep.objectSchema = this.dataSourceService.createNewObjectSchema();
                        newStep.objectSchema.name = "Single Page";
                        this.formConfiguration.mySteps.push(newStep);
                        //console.log("Adding Step");
                        this.currentStep = newStep;
                        return true;
                    }
                }
                return false;
            };
            return BaseOnePageFormModel;
        }(directives.BaseFormModel));
        directives.BaseOnePageFormModel = BaseOnePageFormModel;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
